import { Button, Col, Row } from "reactstrap";
import styles from "./stepperActionButton.module.scss";
const StepperActionButtons = props => {
  const handleBack = () => {
    props.previousStep();
  };

  const handleNext = () => {
    props.nextStep();
  };

  return (
    <div className={styles["container-action"]}>
      <Row>
        <Col md={4} sm={4} xs={4}>
          <Button outline className={styles["back"] + " float-left"} onClick={props.close}>
            ANNULER
          </Button>
        </Col>

        <Col md={8} sm={8} xs={8} className="p-0">
          {props.currentStep < props.totalSteps && (
            <Button outline color="success" disabled={props.disable} className={styles["submit"] + " float-right"} onClick={handleNext}>
              Suivant
            </Button>
          )}
          {props.currentStep === props.totalSteps && (
            <Button outline color="success" disabled={props.disable} className={styles["submit"] + " float-right"} onClick={props.last}>
              Valider
            </Button>
          )}
          {props.currentStep > 1 && (
            <Button outline className={styles["cancel"] + " float-right"} onClick={handleBack}>
              Précédent
            </Button>
          )}
        </Col>
      </Row>
    </div>
  );
};
export default StepperActionButtons;
